import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers, faCheck, faUsersCog, faAward } from "@fortawesome/free-solid-svg-icons";
import CountUp from "react-countup";
import bgImage from "../assets/img/bg.png"; // <-- Import your image
import "../App.css";

const factsData = [
  { icon: faUsers, count: 1000, label: "Happy Clients", delay: "0.1s" },
  { icon: faCheck, count: 500, label: "Projects Completed", delay: "0.3s" },
  { icon: faUsersCog, count: 100, label: "Dedicated Staff", delay: "0.5s" },
  { icon: faAward, count: 100, label: "Awards Achieved", delay: "0.7s" },
];

const Facts = () => {
  const [visibleIndexes, setVisibleIndexes] = useState([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = Number(entry.target.dataset.index);
            if (!visibleIndexes.includes(index)) {
              setVisibleIndexes((prev) => [...prev, index]);
            }
          }
        });
      },
      { threshold: 0.3 }
    );

    document.querySelectorAll(".fact-item").forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, [visibleIndexes]);

  return (
    <div
      className="container-fluid facts my-5 py-5"
      style={{
        background: `linear-gradient(rgba(53,94,252,0.95), rgba(53,94,252,0.95)), url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="container py-5">
        <div className="row g-5 text-center">
          {factsData.map((fact, i) => (
            <div
              key={i}
              className="col-sm-6 col-lg-3 fade-on-scroll fact-item"
              data-index={i}
              style={{ animationDelay: fact.delay }}
            >
              <FontAwesomeIcon icon={fact.icon} className="fa-3x text-white mb-3" />
              <h1 className="display-4 text-white">
                {visibleIndexes.includes(i) ? (
                  <CountUp start={0} end={fact.count} duration={2} />
                ) : (
                  0
                )}+
              </h1>
              <span className="fs-5 text-white">{fact.label}</span>
              <hr className="bg-white w-25 mx-auto mb-0" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Facts;
